import { History } from 'history'

// TODO make part of router ?
export class PreviousLocationDetector {
    private appNavigationDepth: number
    private initialHistoryLen: number

    constructor(private history: History) {
        this.appNavigationDepth = 0
        this.initialHistoryLen = history.length
        history.listen(() => {
            const action = history.action

            if (action === 'REPLACE' || action === 'POP') {
                this.appNavigationDepth--
            } else {
                this.appNavigationDepth++
            }
        })
    }

    wasPreviouslyInApp = (): boolean => {
        return this.appNavigationDepth > 0
    }
}
